const e = () => typeof window < "u" && typeof document < "u";
export {
  e as isBrowser
};
